// app/javascript/dashboard/i18n/index.js
import en from './locale/en';
import es from './locale/es';

export default {
  en,
  es,
};